// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    
    background: var(--bg-card);
    color: var(--texto-principal);
    border: 1px solid var(--color-borders);
    
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: var(--sombra-card);
    
    display: flex;
    align-items: flex-start;
    gap: 12px;
    z-index: 9999;
    min-width: 300px;
    max-width: 400px;
    animation: slideIn 0.3s ease-out;
    border-left: 4px solid transparent;
    font-family: inherit;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Variantes por tipo (Usamos las variables globales de score/color) */
.toast-success {
    border-left-color: var(--score-verde);
}

.toast-error {
    border-left-color: var(--score-rojo);
}

.toast-info {
    border-left-color: var(--primary-blue);
}

/* Iconos */
.toast-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    font-size: 1.25rem;
}

.toast-success .toast-icon {
    color: var(--score-verde);
}

.toast-error .toast-icon {
    color: var(--score-rojo);
}

.toast-info .toast-icon {
    color: var(--primary-blue);
}

/* Mensaje */
.toast-message {
    flex: 1 1;
}

.toast-message p {
    margin: 0;
    font-size: 0.95rem;
    
    color: var(--texto-principal);
    
    font-weight: 500;
    line-height: 1.4;
}

/* Boton cerrar */
.toast-close {
    background: none;
    border: none;
    cursor: pointer;
    color: var(--color-gray-text);
    padding: 0;
    display: flex;
    align-items: center;
    transition: color 0.2s;
}

.toast-close:hover {
    color: var(--texto-principal);
}

/* Barra de progreso */
.toast-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    
    background-color: var(--color-borders); 
    
    width: 100%;
    animation: progress 4s linear forwards;
}

.toast-success .toast-progress { background-color: var(--score-verde); opacity: 0.3; }
.toast-error .toast-progress { background-color: var(--score-rojo); opacity: 0.3; }
.toast-info .toast-progress { background-color: var(--primary-blue); opacity: 0.3; }

@keyframes progress {
    from {
        width: 100%;
    }
    to {
        width: 0%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NotificationToast/notificationToast.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;;IAEX,0BAA0B;IAC1B,6BAA6B;IAC7B,sCAAsC;;IAEtC,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;;IAE9B,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,sEAAsE;AACtE;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,kBAAkB;;IAElB,6BAA6B;;IAE7B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;;IAEX,sCAAsC;;IAEtC,WAAW;IACX,sCAAsC;AAC1C;;AAEA,iCAAiC,oCAAoC,EAAE,YAAY,EAAE;AACrF,+BAA+B,mCAAmC,EAAE,YAAY,EAAE;AAClF,8BAA8B,qCAAqC,EAAE,YAAY,EAAE;;AAEnF;IACI;QACI,WAAW;IACf;IACA;QACI,SAAS;IACb;AACJ","sourcesContent":[".toast-container {\r\n    position: fixed;\r\n    top: 20px;\r\n    right: 20px;\r\n    \r\n    background: var(--bg-card);\r\n    color: var(--texto-principal);\r\n    border: 1px solid var(--color-borders);\r\n    \r\n    padding: 16px 20px;\r\n    border-radius: 8px;\r\n    box-shadow: var(--sombra-card);\r\n    \r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n    z-index: 9999;\r\n    min-width: 300px;\r\n    max-width: 400px;\r\n    animation: slideIn 0.3s ease-out;\r\n    border-left: 4px solid transparent;\r\n    font-family: inherit;\r\n}\r\n\r\n@keyframes slideIn {\r\n    from {\r\n        transform: translateX(100%);\r\n        opacity: 0;\r\n    }\r\n    to {\r\n        transform: translateX(0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n/* Variantes por tipo (Usamos las variables globales de score/color) */\r\n.toast-success {\r\n    border-left-color: var(--score-verde);\r\n}\r\n\r\n.toast-error {\r\n    border-left-color: var(--score-rojo);\r\n}\r\n\r\n.toast-info {\r\n    border-left-color: var(--primary-blue);\r\n}\r\n\r\n/* Iconos */\r\n.toast-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 2px;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.toast-success .toast-icon {\r\n    color: var(--score-verde);\r\n}\r\n\r\n.toast-error .toast-icon {\r\n    color: var(--score-rojo);\r\n}\r\n\r\n.toast-info .toast-icon {\r\n    color: var(--primary-blue);\r\n}\r\n\r\n/* Mensaje */\r\n.toast-message {\r\n    flex: 1;\r\n}\r\n\r\n.toast-message p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n    \r\n    color: var(--texto-principal);\r\n    \r\n    font-weight: 500;\r\n    line-height: 1.4;\r\n}\r\n\r\n/* Boton cerrar */\r\n.toast-close {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: var(--color-gray-text);\r\n    padding: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.toast-close:hover {\r\n    color: var(--texto-principal);\r\n}\r\n\r\n/* Barra de progreso */\r\n.toast-progress {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    height: 3px;\r\n    \r\n    background-color: var(--color-borders); \r\n    \r\n    width: 100%;\r\n    animation: progress 4s linear forwards;\r\n}\r\n\r\n.toast-success .toast-progress { background-color: var(--score-verde); opacity: 0.3; }\r\n.toast-error .toast-progress { background-color: var(--score-rojo); opacity: 0.3; }\r\n.toast-info .toast-progress { background-color: var(--primary-blue); opacity: 0.3; }\r\n\r\n@keyframes progress {\r\n    from {\r\n        width: 100%;\r\n    }\r\n    to {\r\n        width: 0%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
